import { sub } from 'date-fns';

import { formatDate, PPP } from 'helpers/date';

/**
 * Returns a localized formatted date 3 months ago. For example on the
 * 17/08/2021 it returns either "17 mai 2021" or "May 17th, 2021"
 * based on the user locale
 */
export const getFormattedDateThreeMonthsAgo = () =>
  formatDate(sub(new Date(), { months: 3 }), PPP);
